var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-book-submission-min-date"},[_vm._v(_vm._s(_vm.minDiscoveryLaunchDate.duration)+" "+_vm._s(_vm.minDiscoveryLaunchDate.type))])}
var staticRenderFns = []

export { render, staticRenderFns }